export function brToIsoDate(value: string): string {
    const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value.trim());
    if (!match) return '';
    const [, day, month, year] = match;
    return `${year}-${month}-${day}`;
}

export function isoToBrDate(value: string): string {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
    if (!match) return '';
    const [, year, month, day] = match;
    return `${day}/${month}/${year}`;
}
